const sessions = [
  {
    label: '3 Sessions',
    value: '3',
  },
  {
    label: '6 Sesions',
    value: '6 ',
  },
  {
    label: '12 Sessions',
    value: '12',
  },
  {
    label: 'Assessments',
    value: '0',
  },
];

export default sessions;
